import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const Header = () => {
  return (
    <motion.header 
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
      className="fixed top-0 left-0 w-full z-50 bg-[#050505]/60 backdrop-blur-xl border-b border-white/5"
    >
      <div className="container mx-auto px-6 h-24 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 h-full py-5 group">
          <img 
            src="https://customer-assets-39nsmqrw.emergentagent.net/job_imvula-refresh/artifacts/e4av7k42_iqp%20white.webp" 
            alt="iMvula Logo" 
            className="h-full object-contain drop-shadow-[0_0_8px_rgba(255,215,0,0.1)] group-hover:drop-shadow-[0_0_12px_rgba(255,215,0,0.3)] transition-all duration-500"
          />
        </Link>
        <nav className="hidden md:flex gap-8 items-center">
          <Link to="/#services" onClick={(e) => {
            if(window.location.pathname === '/') {
              e.preventDefault();
              document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' });
            }
          }} className="text-xs font-space-grotesk font-semibold uppercase tracking-[0.2em] text-gray-400 hover:text-[#FFD700] transition-colors relative group">
            Solutions
            <span className="absolute -bottom-2 left-0 w-0 h-[1px] bg-[#FFD700] transition-all duration-300 group-hover:w-full"></span>
          </Link>
          <Link to="/#locations" onClick={(e) => {
            if(window.location.pathname === '/') {
              e.preventDefault();
              document.getElementById('locations')?.scrollIntoView({ behavior: 'smooth' });
            }
          }} className="text-xs font-space-grotesk font-semibold uppercase tracking-[0.2em] text-gray-400 hover:text-[#FFD700] transition-colors relative group">
            Locations
            <span className="absolute -bottom-2 left-0 w-0 h-[1px] bg-[#FFD700] transition-all duration-300 group-hover:w-full"></span>
          </Link>
          <Link to="/careers" className="text-xs font-space-grotesk font-semibold uppercase tracking-[0.2em] text-gray-400 hover:text-[#FFD700] transition-colors relative group">
            Careers
            <span className="absolute -bottom-2 left-0 w-0 h-[1px] bg-[#FFD700] transition-all duration-300 group-hover:w-full"></span>
          </Link>
          <Link to="/#contact" onClick={(e) => {
            if(window.location.pathname === '/') {
              e.preventDefault();
              document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
            }
          }} className="text-xs font-space-grotesk font-semibold uppercase tracking-[0.2em] text-gray-400 hover:text-[#FFD700] transition-colors relative group">
            Contact
            <span className="absolute -bottom-2 left-0 w-0 h-[1px] bg-[#FFD700] transition-all duration-300 group-hover:w-full"></span>
          </Link>
        </nav>
      </div>
    </motion.header>
  );
};

export default Header;
